
// SVG Icon: compass-outer
export default { id: "terriajs-compass-outer" };
export const id = "terriajs-compass-outer";
export const name = "compass-outer";
